import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const LinkSimpleIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 10" },
        React.createElement("path", { d: "M7 9.5C7 9.77614 6.77614 10 6.5 10H4.5C2.01855 10 0 7.75684 0 5C0 2.24316 2.01855 0 4.5 0H6.5C6.77614 0 7 0.22386 7 0.5V1.5C7 1.77614 6.77614 2 6.5 2H4.5C3.12109 2 2 3.3457 2 5C2 6.6543 3.12109 8 4.5 8H6.5C6.77614 8 7 8.22386 7 8.5V9.5ZM16 5C16 2.24316 13.9815 0 11.5 0H9.5C9.22386 0 9 0.22386 9 0.5V1.5C9 1.77614 9.22386 2 9.5 2H11.5C12.8789 2 14 3.3457 14 5C14 6.6543 12.8789 8 11.5 8H9.5C9.22386 8 9 8.22386 9 8.5V9.5C9 9.77614 9.22386 10 9.5 10H11.5C13.9815 10 16 7.75684 16 5ZM12 5C12 4.44727 11.5527 4 11 4H5C4.44727 4 4 4.44727 4 5C4 5.55273 4.44727 6 5 6H11C11.5527 6 12 5.55273 12 5Z" })));
};

export { LinkSimpleIcon };
//# sourceMappingURL=LinkSimpleIcon.esm.js.map
